<template>
    <div>
        <slot :list="list"></slot>
    </div>
</template>

<script>
import selectpicker from "bootstrap-select";
import Axios from 'axios';

export default {
    data() { return {
        list: [],
    }},
    mounted() {
        const vm = this;
        const filtrosButton = $('#ocultarFiltrosButton');
        const ocultarFiltros = $('#ocultarFiltros');

        const ocultarAlumnosButton = $('#ocultarAlumnosButton');
        const ocultarAlumnos = $('#ocultarAlumnos');
        const submitAlumnos = $('#submitAlumnos');

        const selectInstitucion = $('#institucion_id');
        const selectCiclo = $('#ciclo_escolar_id');

        const selectInstitucionProspectos = $('#institucion_id_prospectos');
        const selectCicloprospectos = $('#ciclo_escolar_id_prospectos');
        const submitButton = $('#submitButton');

        selectInstitucion.on('change', function() {
            selectInstitucionProspectos.selectpicker('val', selectInstitucion.val());
            submitButton.click();
        });

        selectCiclo.on('change', function() {
            selectCicloprospectos.selectpicker('val', selectCiclo.val());
            submitButton.click();
        });

        filtrosButton.on('change', function() {
            ocultarFiltros.toggle();
        });

        ocultarAlumnosButton.on('change', function() {
            ocultarAlumnos.toggle();
        });

        $('#totalProspectosModal').on('show.bs.modal', function (e) {
            vm.get('dashboard/prospectos_total_list');
        });
        $('#totalProspectosInteresadosModal').on('show.bs.modal', function (e) {
            vm.get('dashboard/prospectos_interesados_list');
        });
        $('#totalProspectosInscritosModal').on('show.bs.modal', function (e) {
            vm.get('dashboard/prospectos_inscritos_list');
        });
        $('#totalProspectosCongeladosDescartadosModal').on('show.bs.modal', function (e) {
            vm.get('dashboard/prospectos_congelados_descartados_list');
        });
    },
    methods: {
        get(route) {
            this.data = [];
            const params = this.getParams();
            Axios.get(route, {params: params}).then(res => {
                this.list = res.data;
            }).catch(e => {
                console.log(e);
            })
        },
        getParams() {
            const params = {};
            const data = $('#dbForm').serializeArray();
            data.forEach(item => {
                params[item.name] = item.value;
            });
            return params;
        },
    },
}
</script>